import { WIDGET_ROOT_ID } from '@/helpers/constants';
import type { I_ShadowRootElements } from '@/types/ShadowDom';

/**
 * Creates a shadow DOM structure for the widget
 * @param rootId - The ID for the widget root element
 * @returns An object containing the host element, shadow root, and widget root
 */
export function createShadowRoot(rootId: string = WIDGET_ROOT_ID): I_ShadowRootElements {
  // Create host element (attached to the document)
  const host = document.createElement('div');
  host.id = `${rootId}-host`;

  // Style the host element
  Object.assign(host.style, {
    display: 'block', // !IMPORTANT: Some themes add display: none to empty elements, which would hide the widget
    position: 'relative',
    zIndex: '99999999999',
  });

  // Create shadow root
  const shadowRoot = host.attachShadow({ mode: 'open' });

  // Create widget root inside shadow DOM
  const widgetRoot = document.createElement('div');
  widgetRoot.id = rootId;

  // Style the widget root
  Object.assign(widgetRoot.style, {
    position: 'relative',
  });

  shadowRoot.appendChild(widgetRoot);

  return { host, shadowRoot, widgetRoot };
}
